// GST Type Listing
global.gstTypeList = global.API_ADMIN_URL+'gstTypeList/';
global.adminAddGstType = global.API_ADMIN_URL+'adminAddGstType/';
global.adminEditGstType = global.API_ADMIN_URL+'adminEditGstType/';
global.gstTypeDetails = global.API_ADMIN_URL+'gstTypeDetails/';
global.adminTaxTypeStatus = global.API_ADMIN_URL+'adminTaxTypeStatus/';